import { render, staticRenderFns } from "./ResultMsgModal.vue?vue&type=template&id=55be9298&"
import script from "./ResultMsgModal.vue?vue&type=script&lang=js&"
export * from "./ResultMsgModal.vue?vue&type=script&lang=js&"
import style0 from "./ResultMsgModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports